import React, { Component } from 'react'
import PropTypes from 'prop-types'
import getBoxStatus from "../../../vietnameses/getBoxStatus"
import classNames from 'classnames'
import NextBoxInput from "./NextBoxInput"
import NextBoxPrintQR from "./NextBoxPrintQR"
import NextBoxPrintLLC from "./NextBoxPrintLLC"
import parseBoxStatistics from "../helpers/parseBoxStatistics"
import CloseBox from './CloseBox'
import {listLineship} from "../../helpers/filtersTable"
import isSingleOrderBox from "../../helpers/isSingleOrderBox"

// Các status của thùng sau khi đã đóng (không còn quét hàng vào nữa).
// Liệt kê tường minh thay vì dùng `status !== 'opening'` để status lạ/thiếu
// vẫn giữ hành vi cũ là in "MADE IN VIET NAM".
const CLOSED_BOX_STATUSES = ['closed', 'shipped', 'ship_overdue', 'deleted']


class NextBoxHeader extends Component {
    _parseStatistics = () => {
        const { items } = this.props

        return parseBoxStatistics(items)
    }

    getLineShip = (lineShip) => {
        if (!!lineShip) {
            const mappingLineShips = [...listLineship]
            const lineShipName = mappingLineShips.filter(item => item.value === lineShip)

            return lineShipName[0]
        }
    }

    render() {
        const { box, onRefresh, indexBoxClosed, onUpdateLocalStore, barcodeError, onClose, items } = this.props
        const { id, status, total_items, total_packages, name, warehouse, meta, shipping_carrier, boxQRData } = box
        const { area, product_type, has_wood_product } = { ...meta }
        const statusText = getBoxStatus(status)
        const statistics = this._parseStatistics()
        const lineShip = this.getLineShip(shipping_carrier)
        const boxQRName = boxQRData && boxQRData.name ? boxQRData.name : lineShip && lineShip.name
        const hideMadeInVietnam = CLOSED_BOX_STATUSES.includes(status) && isSingleOrderBox(items)

        return (
            <div className={classNames("NextBoxHeader card-header border-bottom", status)}>
                <h1 className="d-flex justify-content-between flex-wrap">
                    <div className="Left">
                        <span className="Name">Thùng số #{id}</span>
                        <span> - </span>
                        <span>{total_items || 0} sản phẩm</span>
                        <span>  |  </span>
                        <span>{total_packages || 0} gói</span>
                        {boxQRName && (
                            <>
                                <span>  -  </span>
                                <span>{boxQRName || ''}{!!warehouse && `(${warehouse})`}</span>
                            </>
                        )}
                    </div>
                    {!!has_wood_product &&
                        <span className="woodTag">Thùng Sản phẩm Gỗ</span>
                    }

                    <div className="Right d-flex align-middle">
                        <div className="d-flex">
                            <CloseBox barcodeError={barcodeError} onClose={onClose} box={box} position="header" />
                            <NextBoxPrintQR box={box} indexBoxClosed={indexBoxClosed} statistics={statistics} hideMadeInVietnam={hideMadeInVietnam}/>
                            <NextBoxPrintLLC box={box} />
                            <div className="StatusText ml-2">
                                {statusText}
                            </div>
                        </div>
                    </div>
                </h1>

                <NextBoxInput onUpdateLocalStore={onUpdateLocalStore} onRefresh={onRefresh} box={box} items={items} />
            </div>
        )
    }
}

NextBoxHeader.propTypes = {
    box: PropTypes.object.isRequired,
    items: PropTypes.array,
    onRefresh: PropTypes.func.isRequired,
    indexBoxClosed: PropTypes.number,
}

export default NextBoxHeader
